import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/* Stat — the strip of figures across the top of an operational screen.
   Values are tabular so the row does not jitter as they refresh. */

export function StatStrip({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn('grid gap-2.5 [grid-template-columns:repeat(auto-fit,minmax(132px,1fr))]', className)}>
      {children}
    </div>
  )
}

export function Stat(
  { label, value, note, tone, className }:
  { label: ReactNode; value: ReactNode; note?: ReactNode; tone?: string; className?: string },
) {
  return (
    <div className={cn('flex flex-col gap-0.5 rounded-[10px] border border-border bg-card px-3.5 py-3', className)}>
      <span className="text-[11.5px] font-medium text-muted-fg">{label}</span>
      <span className="tnum text-[22px] font-bold leading-tight" style={tone ? { color: tone } : undefined}>
        {value}
      </span>
      {note && <span className="text-[11px] text-muted-fg opacity-80">{note}</span>}
    </div>
  )
}
